/* eslint-disable @typescript-eslint/no-wrapper-object-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {defaultSinistreVoyageError} from '../../data/constants/Sinistres/assuranceVoyage';
import {IError} from '../../data/types/interface/Sinistres/assuranceVoyage';
import {MESSAGE_VALIDATION, TELEPHONE_VALIDATION} from './validation';

const listRequiredField = (
  required: Array<any>,
  notRequired: Array<String>,
) => {
  const aResult = required.filter(elt => !notRequired.includes(elt[0]));
  return aResult;
};

export const Validation = (values: IError, listAgence?: []) => {
  let errors: IError = {...defaultSinistreVoyageError};
  const aNotRequiredField = ['pieceJointeAgence'];
  const aRequiredField = listRequiredField(
    Object.entries(values),
    aNotRequiredField,
  );
  /** agence cheking */
  if (values.agence !== '') {
    const _list = listAgence && [...listAgence];
    const _data =
      _list &&
      _list.filter(
        (item: any) =>
          item.label.toLowerCase().indexOf(values?.agence?.toLowerCase()) > -1,
      );
    const _agence =
      _list && _list.filter((item: any) => item.label === values.agence);

    if ((_data && _data.length === 0) || _agence?.length === 0) {
      errors.agence = MESSAGE_VALIDATION.invalidAgence;
    }
  }

  /** telphone cheking */
  if (!TELEPHONE_VALIDATION.test(values.telephone)) {
    errors.telephone = MESSAGE_VALIDATION.requiredTelephone;
  }

  {
    /** checking all values */
  }
  aRequiredField.forEach(element => {
    if (
      element[1] === '' ||
      element[1] === null ||
      (Array.isArray(element[1]) && element[1].length === 0)
    ) {
      errors = {...errors, [element[0]]: MESSAGE_VALIDATION.requiredField};
    }
  });

  return errors;
};
